<template>
  <div class="interval-selector">
    <div class="steps">
      <span :class="{milestone: item.isMilestone}" v-for="(item, i) in steps" :key="i">
        <em class="milestone-text" v-if="item.isMilestone"
            :class="{'left-edge-text': i === 0, 'right-edge-text': i === steps.length - 1}">{{ item.text }}</em>
      </span>
    </div>
    <div class="interval-bar">
      <span class="left-edge"></span>
      <span class="right-edge"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntervalSelector',
  props: {
    // 最小值
    min: Number,
    // 最大值
    max: Number,
    // 歩长
    step: Number,
    // 自定义标签。格式为 {值: 标签文本}，比如最小值为0，想让其展示的标签为2018，那么就设置{0: 2018}，否则就会展示0
    milestones: Object,
    // 默认区间
    defaultRange: Array,
    onchange: Function
  },
  data() {
    return {
      intervalBar: null
    };
  },
  computed: {
    steps() {
      const steps = [];
      let milestones;
      if (this.milestones) {
        milestones = this.milestones;
      } else {
        milestones = {};
        milestones[this.min] = this.min;
        milestones[this.max] = this.max;
      }
      for (let i = this.min; i <= this.max; i += this.step) {
        steps.push({
          isMilestone: i in milestones,
          text: milestones[i]
        });
      }
      return steps;
    }
  },
  methods: {
    change() {
      if (typeof this.onchange !== 'function') {
        return;
      }
      const stepWidth = this.$el.offsetWidth / (this.max - this.min);
      const barEdgeWidth = this.$el.querySelector('.left-edge').offsetWidth;
      const barOuterLeft = this.intervalBar.offsetLeft;
      const barOuterWidth = this.intervalBar.offsetWidth;
      let start = Math.floor(barOuterLeft / stepWidth);
      let end = Math.floor((barOuterLeft + barOuterWidth) / stepWidth);
      // 如果内部宽度是小于20，很可能是想取一个单位
      const barInnerWidth = barOuterWidth - barEdgeWidth * 2;
      if (barInnerWidth < 20) {
        if (start === 1 * this.min) {
          end = start;
        } else if (end === 1 * this.max) {
          // 如果是想取最后一个
          start = end;
        } else {
          start = Math.floor((barOuterLeft - barEdgeWidth) / stepWidth);
          end = start;
        }
      }
      this.onchange(start, end);
    }
  },
  mounted() {
    const that = this;
    const intervalBar = this.$el.querySelector('.interval-bar');
    this.intervalBar = intervalBar;
    // 设置初始区间
    const defaultRange = this.defaultRange || [];
    const defaultMin = defaultRange.length > 0 ? defaultRange[0] : this.min;
    const defaultMax = defaultRange.length > 1 ? defaultRange[1] : this.max;
    const elWidth = this.$el.offsetWidth;
    intervalBar.style.left = `${elWidth * (defaultMin - this.min) / (this.max - this.min)}px`;
    intervalBar.style.right = `${elWidth * (this.max - defaultMax) / (this.max - this.min)}px`;
    let lastMouseX = 0;
    // 拖动区间条
    intervalBar.addEventListener('mousedown', (evt) => {
      lastMouseX = evt.pageX;
      const drag = (e) => {
        const offsetX = e.pageX - lastMouseX;
        if (offsetX > 0) {
          if (intervalBar.offsetWidth + intervalBar.offsetLeft < that.$el.clientWidth) {
            const ow = intervalBar.clientWidth;
            intervalBar.style.left = `${Math.min(that.$el.clientWidth - ow, intervalBar.offsetLeft + offsetX)}px`;
            intervalBar.style.right = `${Math.max(that.$el.clientWidth - ow - intervalBar.offsetLeft)}px`;
          }
        } else if (intervalBar.offsetLeft > 0) {
          const ow = intervalBar.clientWidth;
          intervalBar.style.left = `${Math.max(0, intervalBar.offsetLeft + offsetX)}px`;
          intervalBar.style.right = `${that.$el.clientWidth - ow - intervalBar.offsetLeft}px`;
        }
        lastMouseX = e.pageX;
      };
      document.addEventListener('mousemove', drag);
      const dragend = () => {
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', dragend);
        that.change();
      };
      document.addEventListener('mouseup', dragend);
    });
    const minBarWidth = intervalBar.querySelector('.left-edge').clientWidth * 2;
    // 拖动区间条左边
    intervalBar.querySelector('.left-edge').addEventListener('mousedown', (evt) => {
      evt.stopPropagation();
      lastMouseX = evt.pageX;
      intervalBar.style.right = `${that.$el.offsetWidth - intervalBar.clientWidth - intervalBar.offsetLeft}px`;
      intervalBar.style.width = 'auto';
      const drag = (e) => {
        e.stopPropagation();
        const offsetX = e.pageX - lastMouseX;
        if (offsetX > 0) {
          if (intervalBar.clientWidth > minBarWidth) {
            intervalBar.style.left = `${intervalBar.offsetLeft + offsetX}px`;
          }
        } else if (intervalBar.offsetLeft > 0) {
          intervalBar.style.left = `${Math.max(0, intervalBar.offsetLeft + offsetX)}px`;
        }
        lastMouseX = e.pageX;
      };
      document.addEventListener('mousemove', drag);
      const dragend = (e) => {
        e.stopPropagation();
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', dragend);
        that.change();
      };
      document.addEventListener('mouseup', dragend);
    });
    // 拖动区间条右边
    intervalBar.querySelector('.right-edge').addEventListener('mousedown', (evt) => {
      evt.stopPropagation();
      lastMouseX = evt.pageX;
      intervalBar.style.left = `${intervalBar.offsetLeft}px`;
      intervalBar.style.right = `${this.$el.clientWidth - intervalBar.clientWidth - intervalBar.offsetLeft}px`;
      intervalBar.style.width = 'auto';
      const drag = (e) => {
        e.stopPropagation();
        const offsetX = e.pageX - lastMouseX;
        const or = this.$el.clientWidth - intervalBar.clientWidth - intervalBar.offsetLeft;
        if (offsetX > 0) {
          if (intervalBar.offsetLeft + intervalBar.clientWidth < that.$el.clientWidth) {
            intervalBar.style.right = `${Math.max(0, or - offsetX)}px`;
          }
        } else if (intervalBar.clientWidth > minBarWidth) {
          intervalBar.style.right = `${Math.min(this.$el.clientWidth - intervalBar.offsetLeft - minBarWidth, or - offsetX)}px`;
        }
        lastMouseX = e.pageX;
      };
      document.addEventListener('mousemove', drag);
      const dragend = (e) => {
        e.stopPropagation();
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', dragend);
        this.change();
      };
      document.addEventListener('mouseup', dragend);
    });
  }
};
</script>

<style lang="scss">
  .interval-selector {
    width: 100%;
    position: relative;
    min-height: 40px;

    .steps {
      display: flex;
      justify-content: space-between;

      span {
        display: inline-block;
        width: 2px;
        height: 19px;
        background-color: #343239;
        position: relative;

        &.milestone {
          height: 30px;
        }

        .milestone-text {
          display: inline-block;
          line-height: 1;
          color: #b5b3b5;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 100%;
          padding-top: 10px;

          &.left-edge-text {
            left: 0;
            right: auto;
            transform: translateX(0);
          }

          &.right-edge-text {
            right: 0;
            left: auto;
            transform: translateX(0);
          }
        }
      }
    }

    .interval-bar {
      height: 19px;
      background-color: #333138;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      cursor: grab;
      position: absolute;
      left: 40%;
      top: 0;

      .left-edge, .right-edge {
        display: inline-block;
        content: '';
        width: 13px;
        height: 19px;
        background-color: #b5b3b5;
        border-radius: 2px;
        cursor: ew-resize;
        flex-shrink: 0;
        position: relative;

        &::before, &::after {
          display: inline-block;
          content: '';
          width: 2px;
          height: 9px;
          background-color: #605e61;
          position: absolute;
          top: 5px;
        }

        &::before {
          left: 30%;
        }

        &::after {
          right: 30%;
        }
      }
    }
  }
</style>
